module.exports = __webpack_public_path__ + "img/honor4.1c0ba9b7.png";